import { render, staticRenderFns } from "./DropDownChoice.vue?vue&type=template&id=b67d029e&scoped=true&"
import script from "./DropDownChoice.vue?vue&type=script&lang=js&"
export * from "./DropDownChoice.vue?vue&type=script&lang=js&"
import style0 from "./DropDownChoice.vue?vue&type=style&index=0&id=b67d029e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67d029e",
  null
  
)

export default component.exports